module.exports = __webpack_public_path__ + "static/media/12n.e56bc41a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/12n.svg
// module id = 161
// module chunks = 0